import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { reviews } from '../mock';

const Reviews = () => {
  return (
    <section id="reviews" className="py-24 bg-[#0B0B0B]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4 font-playfair">What Our Clients Say</h2>
          <div className="w-24 h-1 bg-[#C9A227] mx-auto mb-6"></div>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">Trusted by thousands of satisfied gentlemen across Malaysia</p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <Card key={review.id} className="bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-all duration-300 hover:scale-105">
              <CardContent className="p-8">
                {/* Quote Icon */}
                <div className="mb-6">
                  <Quote className="w-10 h-10 text-[#C9A227] opacity-50" />
                </div>

                {/* Rating */}
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className={`w-5 h-5 ${
                        i < Math.floor(review.rating)
                          ? 'text-[#C9A227] fill-[#C9A227]'
                          : 'text-gray-600'
                      }`}
                    />
                  ))}
                  <span className="ml-2 font-bold text-[#C9A227]">{review.rating}</span>
                </div>

                {/* Comment */}
                <p className="text-gray-300 leading-relaxed mb-6 italic">"{review.comment}"</p>

                {/* Author */}
                <div className="flex items-center justify-between border-t border-white/10 pt-4">
                  <div>
                    <p className="font-bold text-white">{review.name}</p>
                    <p className="text-sm text-gray-500">{review.branch} Branch</p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-gray-500">{review.date}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Overall Rating */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8">
            <div className="flex items-center justify-center space-x-8">
              <div>
                <div className="text-5xl font-bold text-[#C9A227] mb-2 font-playfair">4.9</div>
                <div className="flex items-center space-x-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-6 h-6 text-[#C9A227] fill-[#C9A227]" />
                  ))}
                </div>
                <p className="text-sm text-gray-400">Average Rating</p>
              </div>
              <div className="h-20 w-px bg-white/20"></div>
              <div>
                <div className="text-5xl font-bold text-white mb-2 font-playfair">1,025</div>
                <p className="text-sm text-gray-400">Total Reviews</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;